import React from 'react';
import Link from 'next/link';
import cn from 'classnames';
import { AnchorArrow } from 'react-scale/components';

import DropdownItem from '../../DropdownItem';
import { dropdownItems } from '../../Content';

import styles from '../../../../sections/announcement-banner/AnnouncementBanner.module.css';

const CustomersDropdown = ({ theme, dropdown, navResponsive }) => (
  <div>
    <div className="pt-10 pb-12 px-14" data-first-dropdown-section>
      <div>
        <Link href="/customers">
          <a>
            <h4 className="inline-block mb-6 text-overtitle-sm text-gradient">Customers</h4>
          </a>
        </Link>
        <ul className="grid grid-cols-3 gap-6 w-max">
          {dropdownItems[dropdown].map(item => (
            <DropdownItem
              key={item.title}
              href={item.href}
              icon={item.icon}
              title={item.title}
              text={item.text}
              colors={theme.dropdown.items}
              itemType={item.type}
              navResponsive={navResponsive}
            />
          ))}
        </ul>
      </div>
    </div>
    <div className={cn(theme.rapid.gradient ? styles.gradientRapid : null, 'relative')}>
      <div className={theme.rapid.background}>
        <div className="flex items-center py-6 px-14">
          <div className="relative flex items-center text-sm">
            <AnchorArrow text="See all Customers" href="/customers" theme={theme.theme} />
          </div>
        </div>
      </div>
    </div>
  </div>
);

CustomersDropdown.defaultProps = {
  dropdown: 'customers',
  navResponsive: false
};

export default CustomersDropdown;
